export const getTodayDate = () => new Date().toISOString().split("T")[0];

export const validateAttendanceDateFilters = ({ FromDate, ToDate }) => {
    const today = getTodayDate();

    if (FromDate && FromDate > today) {
        return "From Date cannot be a future date.";
    }

    if (ToDate && ToDate > today) {
        return "To Date cannot be a future date.";
    }

    if (FromDate && ToDate && FromDate > ToDate) {
        return "From Date cannot be greater than To Date.";
    }

    return "";
};
